import { WorkflowState } from '@omnia/ui/src/lib/workflow/models/workflowState'
import type { TicketingSubPages } from '@/common/services/models/pages'

export class TicketingWorkflowState extends WorkflowState<TicketingSubPages> {
    public constructor() {
        super()
        this.currentPage = 'SeatPicker'
    }
    public static readonly StorageKey = 'ticketing-workflow-state'
    public showtimeId?: string
    public orderId?: string
    public continueAsGuest?: boolean
    public isConcessionsEnabled?: boolean
}
